<template>
  <v-app-bar
    color="black"
    dense
    dark
    min-height="6.5vh"
    max-height="6.5vh"
    flat
    class="header-bar"
  >
    <v-toolbar-title class="toolbar-logo">
      <i
        @click="routeToDealers"
        class="icon-hover"
        data-testid="navigation-dealers"
        ><img
          alt="1"
          style="height: 100%; width: 160px"
          svg-inline
          src="@/assets/svg/3xSuperAdminPortalLogo.svg"
      /></i>
    </v-toolbar-title>
    <v-tabs
      height="6.5vh"
      model="tab"
      slider-color="red"
      slider-size="4"
      :optional="navTabsOptional"
      :hide-slider="navTabsOptional"
      v-model="tabsModel"
    >
      <v-tab
        to="/dealers"
        active-class="nav-active"
        data-testid="navigation-dealers"
      >
        <v-icon small class="mr-1">$dealerManagementIcon</v-icon>
        {{ $t('navigation.dealerManagement') }}
      </v-tab>
      <v-tab
        to="/admin-internal"
        active-class="nav-active"
        v-if="showMyUsers"
        data-testid="navigation-internal-admin"
      >
        <v-icon small class="mr-1">$gear</v-icon>
        {{ $t('navigation.administration') }}
      </v-tab>
    </v-tabs>
    <v-spacer></v-spacer>
    <AccountMenu />
  </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AccountMenu from './../AccountMenu.vue'

export default defineComponent({
  name: 'InternalUserDesktopNav',
  components: {
    AccountMenu,
  },
  props: {
    showMyUsers: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tabsModel: null,
    }
  },
  methods: {
    routeToDealers() {
      this.$router.push('/dealers')
    },
  },
  watch: {
    checkTabsModel() {
      if (this.navTabsOptional) this.tabsModel = ''
    },
  },
  computed: {
    checkTabsModel() {
      return this.navTabsOptional
    },
  },
})
</script>
